module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_ta1_ba1_dark.39198f2e.svg";